export const subscriptionTiers = {
  FREELANCER: {
    value: 'FREELANCER',
    label: 'Freelancer',
    name: 'freelancer',
    title: 'Freelancer Plan',
    accountLimit: 'This plan costs $49/mo and starts with one client workspace',
    accountLimitShort: '7 Social Accounts per Client',
    accountLimitDesc: 'You can add up to 7 social media accounts to each client workspace that you have',
    accountPerPlatformLimit: 6,
    includesAutoImporter: true,
    includesMultipleWorkspaces: true,
    ogPrice: 49,
    price: 49,
    defaultWorkspacesCountDisplay: '',
    workspacesPluralSuffix: '',
    pricePerAdditionalWorkspace: 49,
    features: [
      'CaptionAI Caption Generator',
      'Post Scheduling',
      'Live Social Feed',
      'Client Approvals',
      'Client Access Portal',
      'US-based Support Chat',
      'Taggable Content Library',
      'Community Management',
      'Social Media Analytics',
      'Exportable Reports',
      'Unlimited Users',
    ],
  },
  TEAM: {
    value: 'TEAM',
    label: 'Team',
    name: 'team',
    title: 'Team Plan',
    accountLimit: 'This plan costs $199/mo and starts with five client workspaces',
    accountLimitShort: 'Unlimited Social Accounts',
    accountLimitDesc: "Add as many Facebook, Instagram, X (Twitter), or LinkedIn accounts as you'd like!",
    accountPerPlatformLimit: 10000,
    includesAutoImporter: true,
    includesMultipleWorkspaces: true,
    ogPrice: 199,
    price: 199,
    defaultWorkspacesCountDisplay: '5 ',
    workspacesPluralSuffix: 's',
    pricePerAdditionalWorkspace: 29,
    features: [
      'Everything in our Freelancer Plan',
      'White-Labeled Dashboard',
      'White-Labeled Subdomain',
      'Dedicated Account Manager',
      'Unlimited Linked Social Accounts',
      'Team Onboarding',
    ],
  },
  AGENCY: {
    value: 'AGENCY',
    label: 'Agency',
    name: 'agency',
    title: 'Agency Plan',
    accountLimit: 'This plan costs $299/mo and starts with five premium client workspaces',
    accountLimitShort: 'Unlimited Social Accounts',
    accountLimitDesc: "Add as many Facebook, Instagram, X (Twitter), or LinkedIn accounts as you'd like!",
    accountPerPlatformLimit: 10000,
    includesAutoImporter: true,
    includesMultipleWorkspaces: true,
    ogPrice: 299,
    price: 299,
    defaultWorkspacesCountDisplay: '5 ',
    workspacesPluralSuffix: 's',
    pricePerAdditionalWorkspace: 35,
    features: [
      'Everything in our Team Plan',
      'Advertising Analytics',
      'Single Sign On (SSO)',
      'Custom Domain',
      'White-Labeled Email Domain',
      'Quarterly Business Reviews',
      'White-Labeled Marketing Materials and Pitch Deck',
      'Access to our Premier Partner Program',
      'Client Migration (up to 100 clients)',
    ],
  },
};